import type { VideoFrameV2 } from '@mimir/cutter/frameProvider/frameProvider';
import { getInternalVideoFrame } from '@mimir/browser/buffer/videoFrameBuffer';
import { ImageBitmapBuffer } from './imageBitmapBuffer';

export function tryVideoFrameAsTexImageSource(sourceVideoFrame: VideoFrameV2): TexImageSource | null{

  const internalVideoFrame = getInternalVideoFrame(sourceVideoFrame);
  if (internalVideoFrame) {
    return internalVideoFrame;
  }

  const buf = sourceVideoFrame.buffer;
  if (buf instanceof ImageBitmapBuffer) {
    return buf.imageBitmap;
  }

  return null;
}

